export const freedSpotMarkerDataSelector = ({freedSpotMarkerData}) => freedSpotMarkerData